import React from 'react';
import { Mail, Phone, MapPin, Facebook, Instagram, Linkedin, Clock } from 'lucide-react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-gradient-to-br from-gray-900 to-gray-800 text-white" data-testid="site-footer">
      {/* Newsletter Section */}
      <div className="bg-gradient-to-r from-yellow-500 to-orange-500 py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col md:flex-row items-center justify-between gap-6">
            <div>
              <h3 className="text-3xl font-black mb-2">FIQUE POR DENTRO</h3>
              <p className="text-lg">Receba novidades e ofertas exclusivas</p>
            </div>
            <div className="flex gap-3 w-full md:w-auto">
              <input
                type="email"
                placeholder="Seu melhor e-mail"
                className="flex-1 md:w-80 px-6 py-3 rounded-full text-gray-800 focus:outline-none focus:ring-4 focus:ring-cyan-300"
                data-testid="newsletter-email"
              />
              <button
                className="bg-blue-700 hover:bg-blue-800 text-white font-bold px-8 py-3 rounded-full transition-all transform hover:scale-105 shadow-lg"
                data-testid="newsletter-submit"
              >
                ENVIAR
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Main Footer Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          {/* Company Info */}
          <div>
            <h3 className="text-3xl font-black text-blue-600 mb-4">ELETROVEX</h3>
            <p className="text-gray-400 mb-2">
              Qualidade, Confiança e Desempenho em soluções de ventilação, exaustão e peças para fogão.
            </p>
            <p className="text-gray-500 text-xs mb-4">
              CNPJ: 54.800.775/0001-70
            </p>
            <div className="flex gap-4">
              <a href="#" className="bg-blue-700 hover:bg-blue-800 p-2 rounded-full transition-colors" aria-label="Facebook">
                <Facebook size={20} />
              </a>
              <a href="#" className="bg-yellow-500 hover:bg-yellow-600 p-2 rounded-full transition-colors" aria-label="Instagram">
                <Instagram size={20} />
              </a>
              <a href="#" className="bg-blue-700 hover:bg-blue-800 p-2 rounded-full transition-colors" aria-label="LinkedIn">
                <Linkedin size={20} />
              </a>
            </div>
          </div>

          {/* Products */}
          <div>
            <h4 className="text-lg font-bold mb-4 text-blue-400">PRODUTOS</h4>
            <ul className="space-y-2">
              <li><a href="/#exaustores" className="text-gray-400 hover:text-white transition-colors">Exaustores ITC</a></li>
              <li><a href="/#kits" className="text-gray-400 hover:text-white transition-colors">Kits Completos</a></li>
              <li><a href="/#churrasqueira" className="text-gray-400 hover:text-white transition-colors">Exaustores para Churrasqueira</a></li>
              <li><a href="/#cooktops" className="text-gray-400 hover:text-white transition-colors">Cooktops</a></li>
              <li><a href="/#pecas" className="text-gray-400 hover:text-white transition-colors">Peças de Fogão</a></li>
            </ul>
          </div>

          {/* Help */}
          <div>
            <h4 className="text-lg font-bold mb-4 text-blue-400">AJUDA</h4>
            <ul className="space-y-2">
              <li><Link to="/sobre" className="text-gray-400 hover:text-white transition-colors" data-testid="footer-sobre">Sobre Nós</Link></li>
              <li><Link to="/contato" className="text-gray-400 hover:text-white transition-colors" data-testid="footer-contato">Contato</Link></li>
              <li><Link to="/trocas" className="text-gray-400 hover:text-white transition-colors" data-testid="footer-trocas">Política de Trocas</Link></li>
              <li><Link to="/rastreio" className="text-gray-400 hover:text-white transition-colors" data-testid="footer-rastreio">Rastrear Pedido</Link></li>
              <li><Link to="/termos" className="text-gray-400 hover:text-white transition-colors" data-testid="footer-termos">Termos de Uso</Link></li>
              <li><Link to="/privacidade" className="text-gray-400 hover:text-white transition-colors" data-testid="footer-privacidade">Privacidade</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-lg font-bold mb-4 text-blue-400">CONTATO</h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-2 text-gray-400">
                <Phone size={20} className="text-blue-400 mt-1 flex-shrink-0" />
                <a
                  href="https://wa.me/5547984931793"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-white transition-colors"
                  data-testid="footer-whatsapp"
                >
                  +55 (47) 98493-1793
                </a>
              </li>
              <li className="flex items-start gap-2 text-gray-400">
                <Mail size={20} className="text-blue-400 mt-1 flex-shrink-0" />
                <a href="mailto:joaquim@eletrovex.com.br" className="hover:text-white transition-colors" data-testid="footer-email">
                  joaquim@eletrovex.com.br
                </a>
              </li>
              <li className="flex items-start gap-2 text-gray-400">
                <Clock size={20} className="text-blue-400 mt-1 flex-shrink-0" />
                <p>Seg a Sex, das 7h às 18h</p>
              </li>
              <li className="flex items-start gap-2 text-gray-400">
                <MapPin size={20} className="text-blue-400 mt-1 flex-shrink-0" />
                <p>Jaraguá do Sul, 335<br/>Nova Brasília — Santa Catarina<br/>CEP 89253-000</p>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-gray-700">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-400 text-sm">
              © {new Date().getFullYear()} ELETROVEX — Todos os direitos reservados.
            </p>
            <div className="flex gap-6 text-sm">
              <Link to="/privacidade" className="text-gray-400 hover:text-white transition-colors">
                Política de Privacidade
              </Link>
              <Link to="/termos" className="text-gray-400 hover:text-white transition-colors">
                Termos de Uso
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
